<template>
    <section class="invoice-add-wrapper">
      <BRow class="invoice-add">
  
        <!-- Col: Left (Invoice Container) -->
        <BCol cols="12" xl="9" md="8">

          <ValidationObserver ref="form">
          <BForm>
            <BCard no-body class="invoice-preview-card">
              <!-- Header -->
              <BCardBody class="invoice-padding pb-0">
                <div class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0">
  
                  <!-- Header: Left Content -->
                  <div>
                    <div class="logo-wrapper">
                      <BImg :src="appLogoImage" width="50" />
                      <h3 class="text-primary invoice-logo"> {{ appName }} </h3>
                    </div>
                  </div>
  
                  <!-- Header: Right Content -->
                  <div class="invoice-number-date mt-md-0 mt-2">
                    <div class="d-flex align-items-center mb-1">
                      <span class="title"> {{ $t('Emit Date') }}: </span>
                      <flatPickr v-model="invoice.emit_date" class="form-control invoice-edit-input" :config="{dateFormat: 'd-m-Y'}" />
                    </div>
                    <div class="d-flex align-items-center">
                      <span class="title"> {{$t('Due Date')}}: </span>
                      <flatPickr v-model="invoice.payment_date" class="form-control invoice-edit-input" :config="{ minDate: invoice.emit_date, dateFormat: 'd-m-Y' }" />
                    </div>
                  </div>
                </div>
              </BCardBody>
            
              <!-- Spacer -->
              <hr class="invoice-spacing">
              <!-- Expense Client & Payment Details -->
             
            <BRow class="invoice-spacing p-2">
        
            <BRow class=" w-100" v-if="accounts">

              <BCol md="6" cols="12" v-if="invoice && accounts">
                <!-- Col: Number expense + account -->
                <TextInputValidated cols="12" :vsModel.sync="invoice.expense_code" vsName="Código de factura" vsRequired vsRules="required" />
                <div class="d-flex">
                  <VSelectValidated cols="12" vsName="Cuenta" :vsModel.sync="invoice.account"  :vsOptions="accounts"  vsLabel="search_name" vsRequired vsRules="required" @vsOnInput="updateAccountForm"/>
                  <BButton variant="flat-info" class="btn-icon" @click="isSidebarActive=true">
                    <FeatherIcon size="18" icon="PlusIcon" />
                  </BButton>  
                </div>
              </BCol>

              <!-- Col: Payment Details -->
              <BCol v-if="invoice.account" md="6" cols="12"  class="mt-xl-0 mt-2 justify-content-end d-xl-flex d-block pl-3" >
                <div v-if="invoice.account != null">

                  <BCol>
                  <h6 class="mb-2"> {{ $t('Payment Details') }}: </h6>
                  <table>
                    <tbody>
                      <tr v-if="invoice.account">
                        <td class="pr-1"> {{ $t('Bank account') }}:</td>
                        <td>{{ invoice.customer_billing_account  }}</td>
                      </tr>
                      <tr>
                        <td class="pr-1">{{ $t('Name') }}:</td>
                        <td>{{    invoice.customer_billing_full_name    }}</td>
                      </tr>
                      <tr>
                        <td class="pr-1">{{ $t('NIF') }}:</td>
                        <td>{{   invoice.customer_billing_nif }}</td>
                      </tr>
                      <tr>
                        <td class="pr-1">{{ $t('Address') }}:</td>
                        <td>{{  invoice.customer_billing_address  }}</td>
                      </tr>
                      <tr>
                        <td class="pr-1">{{ $t('City') }}:</td>
                        <td>{{ invoice.customer_billing_city  }}</td>
                      </tr>
                      <tr>
                        <td v-if="invoice.customer_billing_province" class="pr-1">{{ $t('Province') }}:</td>
                        <td><span >{{ invoice.customer_billing_province  }}</span></td>
                      </tr>
                      <tr v-if="invoice.customer_billing_postal_code">
                        <td  class="pr-1">{{ $t('Postal code') }}:</td>
                        <td>{{ invoice.customer_billing_postal_code }}</td>
                      </tr>
                      <tr>
                        <td class="pr-1"> {{ $t('Country') }}:</td>
                        <td><span v-if="invoice.customer_billing_country">{{ invoice.customer_billing_country }}</span></td>
                      </tr>
                      <tr>
                        <td class="pr-1"></td>
                      </tr>
                    </tbody>
                  </table>
                  </BCol>
                </div>
              </BCol>
      </BRow>
    
      </BRow>
              <!-- Items Section -->
              <BCardBody class="invoice-padding form-item-section">
                <div ref="form" class="repeater-form" :style="{height: trHeight}">
                  <BRow v-for="(item, index) in invoice.items" :key="index" ref="row" class="pb-2">
  
                    <!-- Item Form -->
                    <!-- ? This will be in loop => So consider below markup for single item -->
                    <BCol cols="12">
  
                      <!-- Form Input Fields OR content inside bordered area  -->
                      <!-- ? Flex to keep separate width for XIcon and SettingsIcon -->
                      <div class="d-flex border rounded">
                        <BRow class="flex-grow-1 p-2 " v-if="taxesOptions && pitsOptions">
                          <!-- Single Item Form Headers -->
                          <BCol cols="12" lg="8">
                            <BRow>
                              <TextInputValidated :vsModel.sync="item.name" vsName="Item"  vsLabel="item" vsLg="4" vsRequired vsRules="required" />
                              <NumberInputValidated vsName="Amount"  vsLabel="amount" vsLg="4" vsRequired vsRules="required:true"  :vsModel.sync="item.amount" />
                              <NumberInputValidated vsName="Quantity"  vsLabel="quantity" vsLg="4" vsRequired vsRules="required:true|min_value: 1" :vsModel.sync="item.quantity" />
                              <VSelectValidated vsName="IVA" :vsModel.sync="item.vat" :vsOptions="taxesOptions" vsLabel="name" vsRequired vsRules="required" :vsReduce="tax=>tax.value" vsLg="4"/>
                              <VSelectValidated vsName="IRPF" :vsModel.sync="item.pit" :vsOptions="pitsOptions" vsLabel="name" :vsClearable="true" :vsReduce="pit=>pit.value" vsLg="4"/>
                              <NumberInputValidated vsName="Descuento %"  vsLabel="discount" vsLg="4" :vsModel.sync="item.discount" />
                            </BRow>
                          </BCol>
                          <BCol cols="12" lg="2"  >
                            <div class="">
                              <p > Precio: </p>
                              <p class="font-weight-bold"> {{ formatCurrency(getItemTaxableBase(item)) }} </p>
                            </div>   
                          </BCol> 
                          <BCol cols="12" lg="2"  >
                            <div class="" >
                              <p > Precio + impuestos: </p>
                              <p class="font-weight-bold"> {{ formatCurrency(calculateItem(item)) }} </p>
                            </div>    
                          </BCol>
                          <BCol cols="12" class="pt-2">
                                <BButton v-b-toggle:advanced-options variant="flat-secondary" class="m-0 p-0 d-flex align-items-center">          
                                  <feather-icon icon="ChevronDownIcon" size="16"/> <small>Más</small>
                                </BButton>
                                <BCollapse id="advanced-options">
                                  <BRow class="pt-2">
                                    <VSelectValidated v-if="expenseItemTypeOptions" vsName="Tipo" :vsModel.sync="item.is_active" :vsOptions="expenseItemTypeOptions" vsLabel="text" :vsReduce="opt=>opt.value" vsMd="4" :vsClearable="true" @vsOnInput="onItemTypeInput(item, null)"/>
                                    <VSelectValidated v-if="!item.is_active && expenseAccountingOptions" vsName="Cuenta contable de gasto" :vsModel.sync="item.accounting_account" :vsOptions="expenseAccountingOptions" vsLabel="search_name" :vsClearable="true" vsMd="4" @vsOnInput="(val) => onAccountingInput(item, val)"/>
                                    <VSelectValidated v-if="!item.is_active && item.accounting_account" vsName="Subcuenta contable de gasto" :vsModel.sync="item.accounting_subaccount" :vsOptions="item.accounting_account.accounting_subaccounts" vsLabel="search_name" :vsReduce="option => option.id" :vsClearable="true" vsMd="4"/>

                                    <VSelectValidated v-if="item.is_active && immobilizedAccountingOptions" vsName="Categoría de activo" :vsModel.sync="item.accounting_account" :vsOptions="immobilizedAccountingOptions" vsLabel="search_name" :vsClearable="true" vsMd="4" @vsOnInput="(val) => onAccountingInput(item, val)"/>
                                    <VSelectValidated v-if="item.is_active && item.accounting_account" vsName="Subcategoría de activo" :vsModel.sync="item.accounting_subaccount" :vsOptions="item.accounting_account.accounting_subaccounts" vsLabel="search_name" :vsReduce="option => option.id" :vsClearable="true" vsMd="4"/>

                                    <BCol v-if="!item.accounting_account" vsMd="4"></BCol>
                                    <NumberInputValidated vsName="Ded. IVA %"  vsLabel="iva" vsLg="4" :vsModel.sync="item.vat_deduction" />
                                    <NumberInputValidated v-if="!item.is_active" vsName="Ded. gasto %"  vsLabel="gasto" vsLg="4" :vsModel.sync="item.expense_deduction" />
                                    <BCol cols="12">
                                      <BFormTextarea v-model="item.observations" max-rows="3" class="mb-2 mb-lg-0" :disabled="item.name == ''"/>
                                    </BCol>

                                  </BRow>
                                </BCollapse>
                              </BCol> 
                        </BRow>
                        <div class="d-flex flex-column justify-content-between border-left py-50 px-25">
                          <feather-icon size="16" icon="XIcon" class="cursor-pointer" @click="removeItem(index)"/>
       
                       
                      </div>
                      
                      </div>

                      
                    </BCol>
                  </BRow>
                </div>
                <BButton v-ripple.400="'rgba(255, 255, 255, 0.15)'" size="sm" variant="primary" @click="addNewItemInItemForm"> {{$t('Add Item')}} </BButton>
              </BCardBody>
  
              <!-- Invoice Description: Total -->
              <BCardBody class="invoice-padding pb-0">
                <BRow>
  
                  <!-- Col: Sales Person -->
                  <BCol cols="12" md="6" class="mt-md-0 mt-3 d-flex align-items-center" order="2" order-md="1">
                    <label for="invoice-data-sales-person" class="text-nowrap mr-50">{{ $t('User') }}:</label>
                    <BFormInput id="invoice-data-sales-person" v-model="invoice.user_full_name" disabled/>
                  </BCol>
  
                  <!-- Col: Total -->
                  <BCol cols="12" md="6" class="mt-md-6 d-flex justify-content-end" order="1" order-md="2">
                    <div class="invoice-total-wrapper">
                      <div class="invoice-total-item">
                        <p class="invoice-total-title"> Subtotal: </p>
                        <p class="invoice-total-amount"> {{ formatCurrency(invoice.subtotal)}} </p>
                      </div>
                      <div class="invoice-total-item">
                        <p class="invoice-total-title"> Descuentos: </p>
                        <p class="invoice-total-amount"> {{ formatCurrency(invoice.discounts)}} </p>
                      </div>
                      <div class="invoice-total-item">
                        <p class="invoice-total-title"> Base imponible: </p>
                        <p class="invoice-total-amount"> {{ formatCurrency(invoice.taxableBase)}} </p>
                      </div>
                      <div class="invoice-total-item" v-for="(vat, index) in invoice.vats" :key="index">
                          <p class="invoice-total-title"> IVA {{ vat.value }}%</p>
                          <p class="invoice-total-amount"> {{formatCurrency(vat.price)}} </p>
                      </div>
                      <div class="invoice-total-item" v-for="(pit, index) in invoice.pits" :key="pit.value">
                          <p class="invoice-total-title"> IRPF {{ pit.value }}%</p>
                          <p class="invoice-total-amount"> {{formatCurrency(pit.price)}}</p>
                      </div>
                      <hr class="my-50">
                      <div class="invoice-total-item">
                        <p class="invoice-total-title"> {{ $t('Total') }}: </p>
                        <p class="invoice-total-amount"> {{formatCurrency(invoice.amount)}} </p>
                      </div>
                    </div>
                  </BCol>
                </BRow>
                
              </BCardBody>
  
              <!-- Spacer -->
              <hr class="invoice-spacing">
  
              <!-- Note -->
              <BCardBody class="invoice-padding pt-0">
                <span class="font-weight-bold">{{ $t('Note') }}: </span>
                <BFormTextarea v-model="invoice.note" />
              </BCardBody>
            </BCard>
          </BForm>
        </ValidationObserver>
        </BCol>
        <!-- Right Col: Card -->
        <BCol cols="12" md="4" xl="3" class="invoice-actions mt-md-0 mt-2">
          <div class="row">

            <!-- Action Buttons -->
            <BCard class="mt-2 mt-md-0 col-12 order-2 order-md-1">
              <BButton v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="primary" @click="submit" block> {{ $t('Save') }} </BButton>
              <BButton variant="outline-danger" :to="{ name: 'expenses' }" block>{{ $t('Cancel') }}</BButton>
            </BCard>
  
            <!-- Payment Method -->
            <div class=" col-12 order-1 order-md-2" >
              <ValidationObserver ref="formPaymentMethod">
                <VSelectValidated v-if="groupsOptions && groupsOptions.length>1" vsName="Sucursal" :vsModel.sync="invoice.group" :vsOptions="groupsOptions" vsLabel="name" vsRequired vsRules="required" />  
                <VSelectValidated v-if="groupsOptions && invoice.group" vsName="Serie" :vsModel.sync="invoice.serie" @vsOnInput="setEconomicActivity" :vsOptions="invoice.group.expense_series" vsLabel="search_name" vsRequired vsRules="required" :vsDisabled="invoice.group.expense_series.length==1" />
                <VSelectValidated vsName="Actividad económica" :vsModel.sync="invoice.economic_activity_id" :vsOptions="economicActivityOptions" vsLabel="name" vsRequired vsRules="required" :vsReduce="ec => ec.id" />
                <VSelectValidated vsName="Payment method" :vsModel.sync="invoice.payment_method_id" :vsOptions="paymentMethodsOptions" vsLabel="name" vsRequired vsRules="required" :vsReduce="payment_method => payment_method.id" v-if="paymentMethodsOptions" />

                <VSelectValidated v-if="cashesOptions && showCashes"  vsName="Caja" :vsModel.sync="invoice.cash_id" :vsOptions="cashesOptions" vsLabel="name" vsRequired :vsRules="showCashes ? 'required': ''" :vsReduce="cash => cash.id" />

                <CheckboxValidated vsName="Pagado" :vsModel.sync="invoice.paid" vsLabel="Pagado" />

                <BCol>
                  <ValidationProvider #default="validationContext">
                    <BFormRadioGroup v-model="type"  class="price-range-defined-radio-group d-flex " stacked >
                      <BFormRadio  class="pr-1" v-for="p in typeOptions" :key="p.text" :value="p.value" >{{ p.text }} </BFormRadio>
                    </BFormRadioGroup>
                  </ValidationProvider>
                </BCol>

              </ValidationObserver>
              
              
            </div>
          </div>
        </BCol>
      </BRow>
      <InvoiceSidebarAddNewCustomer parent="expense" @new-account-added="fetchAccounts"/>
    </section>
  </template>
  
  <script>
  import { BRow, BCol, BCard, BCardBody, BButton, BCardText, BForm, BFormGroup, BFormInput, BInputGroup, BInputGroupPrepend, BFormTextarea, BFormCheckbox, BPopover, VBToggle, BImg, BFormRadioGroup, BFormRadio, BCollapse } from 'bootstrap-vue'
  import { heightTransition } from '@core/mixins/ui/transition'
  import { ref, onUnmounted, watch, provide } from '@vue/composition-api'
  import { $themeConfig } from '@themeConfig'
  import flatPickr from 'vue-flatpickr-component'
  import Ripple from 'vue-ripple-directive'
  import popups from '@/hooks/popups'
  import vSelect from 'vue-select'
  import store from '@/store'
  import TextInputValidated from '@/components/forms/TextInputValidated.vue'
  import NumberInputValidated from '@/components/forms/NumberInputValidated.vue'
  import VSelectValidated from '@/components/forms/vSelectValidated.vue'
  import CheckboxValidated from '@/components/forms/CheckboxValidated.vue';
  import axios from '@axios'
  import { ValidationObserver, extend } from 'vee-validate';
  import { max_value, min_value, required } from 'vee-validate/dist/rules';
  import invoiceUtils from '@/hooks/invoiceUtils'
  import currency from '@/utils/currency'
  import { getGroups } from '@/composables/groupService'
  import { getPublicSettings } from '@/composables/settingsService'
  import { getPaymentMethods } from '@/composables/paymentMethodService'
  import { getAccounts } from '@/composables/accountService'
  import { getTaxes } from '@/composables/taxService'
  import { addExpense } from '@/composables/expenseService'
  import InvoiceSidebarAddNewCustomer from '@/components/SidebarAddNewCustomer.vue'

  export default {
    components: { BRow, BCol, BCard, BCardBody, BButton, BCardText, BForm, BFormGroup, BFormInput, BInputGroup, BInputGroupPrepend, BFormTextarea, BFormCheckbox, BPopover, flatPickr, vSelect, BImg , TextInputValidated, NumberInputValidated, VSelectValidated, ValidationObserver, CheckboxValidated, BFormRadioGroup, BFormRadio, InvoiceSidebarAddNewCustomer, BCollapse },
    directives: { Ripple, 'b-toggle': VBToggle },
    mixins: [heightTransition],
    mounted() {
      this.initTrHeight() 
    },
    created() {
      window.addEventListener('resize', this.initTrHeight)
    },
    methods: {
      addNewItemInItemForm() {
        // this.$refs.form.style.overflow = 'hidden'
        this.invoice.items.push(JSON.parse(JSON.stringify(this.item)))
  
        this.$nextTick(() => {
          this.trAddHeight(this.$refs.row[0].offsetHeight)
          setTimeout(() => {
            // this.$refs.form.style.overflow = null
          }, 350)
        })
      },
      removeItem(index) {
        this.invoice.items.splice(index, 1)
        this.trTrimHeight(this.$refs.row[0].offsetHeight)
      },
      initTrHeight() {
        this.trSetHeight(null)
        this.$nextTick(() => {
          this.trSetHeight(this.$refs.form.scrollHeight)
        })
      }
      
    },
    setup(props) {
      const { getItemTaxableBase, calculateInvoice, calculateItem, expenseItemTypeOptions, fetchAccountingAccounts, invoice, setAccountingAccount, economicActivityOptions, onAccountingInput, setEconomicActivity, type, onItemTypeInput} = invoiceUtils()
      const { formatCurrency } = currency()

      const { appName, appLogoImage } = $themeConfig.app
      const { errorToast } = popups()
      const user = JSON.parse(localStorage.getItem('userData'))
      const paymentMethodsOptions = ref(null)
      const itemsOptions = ref([])

      const accounts=ref(null)
      const groupsOptions = ref([])
      const pitsOptions=ref([])
      const taxesOptions = ref([])
      const cashesOptions=ref([])
      const showCashes=ref(false)
      const expenseAccountingOptions=ref([])
      const immobilizedAccountingOptions=ref([])
      const typeOptions= [
            { text: "Factura", value: "n_expense" },
            { text: 'Recibo', value: "n_expense_ticket" },
        ]

      type.value = "n_expense"
      const defaultQuery = ref({
        q: '',
        perPage: 1000,
        page: 1,
        sortBy: 'id',
        sortDesc: true
      })
      const item = {
        name: '',
        vat: null,
        pit: null,
        amount: 0,
        quantity: 1,
        discount: 0,
        observations: '',
        expense_deduction: 100,
        vat_deduction: 100
      }

      const isSidebarActive=ref(false);
      provide('isSidebarActive', isSidebarActive)

      extend('min_value', min_value)
      extend('max_value', max_value)

      const updateAccountForm = (val) => {
        const {  bank_account, billing_address, billing_city, billing_full_name,  billing_name, billing_first_surname, billing_second_surname, billing_nif, billing_postal_code, country, province } = val
        invoice.value.bank_account_iban = bank_account
        invoice.value.customer_billing_full_name = billing_full_name, 
        invoice.value.customer_billing_name = billing_name
        invoice.value.customer_billing_first_surname = billing_first_surname
        invoice.value.customer_billing_second_surname = billing_second_surname
        invoice.value.customer_billing_nif = billing_nif
        invoice.value.customer_billing_address = billing_address
        invoice.value.customer_billing_postal_code = billing_postal_code
        invoice.value.customer_billing_city = billing_city
        invoice.value.customer_billing_province = province ? province.name : null
        invoice.value.customer_billing_country = country  ? country.name  : null
      }
  

      const submit =  function (){
        const promise1 = this.$refs.form.validate();
        const promise2 = this.$refs.formPaymentMethod.validate();

        Promise.all([promise1, promise2]).then( ([success1, success2]) => {
          setAccountingAccount()
          if (success1 && success2) {
            if (type.value=="n_expense") {
              invoice.value.n_expense=true
              invoice.value.n_ticket=null
            } else if (type.value=="n_expense_ticket") {
              invoice.value.n_ticket=true
              invoice.value.n_expense=null
            }
            invoice.value.group ? invoice.value.group_id=invoice.value.group.id : ''
 
            invoice.value.account_id=invoice.value.account.id
            storeExpense(invoice.value, this.$router)
          } else {
          errorToast("Hay algún campo incorrecto o vacío")
        }
        });
      }
      
      const storeExpense = async function (invoice, routerInstance) {
        let response = await addExpense(invoice)
        if (response.data.success) {
          routerInstance.push({ name: 'expenses' })
        } else {
          if (response.data.data) {
            if (response.data.data.expense_code) {
              errorToast('El código de factura ya existe. Por favor, introduce otro.')
            }
          } else {
            errorToast(response.data.msg)
          }
        } 
        
      }

      watch(invoice, () => {

        if (invoice.value.payment_method_id==1 && invoice.value.paid) {
          showCashes.value=true
        } else {
          showCashes.value=false
          invoice.value.cash_id=null
        }
        if (invoice.value.account) {
          invoice.value.payment_method_id=invoice.value.account.payment_method_id
        }

        calculateInvoice()
      }, {deep:true})

      watch(() => invoice.value.group, () => {
        if (invoice.value.group) {
          if (invoice.value.group.expense_series.length==1) {
            invoice.value.serie = invoice.value.group.expense_series[0]
            invoice.value.economic_activity_id=invoice.value.serie.economic_activity_id
          } else  {
            invoice.value.serie = null
            invoice.value.economic_activity_id = null
          }

        }
      })

      //& Consultas
      const fetchAccounts = async function () {
        accounts.value = (await getAccounts()).data.accounts
      }

      const fetchGroups = async function() {
        groupsOptions.value = (await getGroups()).data.groups
      }

      const fetchPits = () => {
        axios.get('pits').then(response => { pitsOptions.value=response.data })
      }

      const fetchTaxes = async function () {
        taxesOptions.value = (await getTaxes())
      }

      const fetchPaymentMethods = function () {
        axios.get('/payment-methods').then(response => {
          paymentMethodsOptions.value = response.data
        })
      }
      
      const fetchCashes = function () {
        axios.get('cashes').then(response => {
          cashesOptions.value=response.data.cashes
        })
      }

      fetchAccounts()
      fetchTaxes()
      fetchPaymentMethods()
      fetchCashes()
      fetchGroups()
      fetchPits()
      fetchAccountingAccounts(2).then((response)=> { expenseAccountingOptions.value = response })
      fetchAccountingAccounts(3).then((response)=> { immobilizedAccountingOptions.value = response} )
      
      return {
        updateAccountForm,
        paymentMethodsOptions,
        itemsOptions,
        appLogoImage,
        accounts,
        appName,
        invoice,
        submit,
        taxesOptions,
        item,
        isSidebarActive,
        pitsOptions,
        accounts,
        cashesOptions,
        showCashes,
        groupsOptions,
        typeOptions,
        type,
        formatCurrency,
        getItemTaxableBase,
        calculateItem,
        fetchAccounts,
        expenseAccountingOptions,
        immobilizedAccountingOptions,
        expenseItemTypeOptions,
        economicActivityOptions,
        onAccountingInput,
        setEconomicActivity,
        onItemTypeInput
      }
    },
  }
  </script>
  
  <style lang="scss">
  @import '~@core/scss/vue/libs/vue-select.scss';
  @import '~@core/scss/vue/libs/vue-flatpicker.scss';
  .invoice-add-wrapper {
    .add-new-client-header {
      padding: $options-padding-y $options-padding-x;
      color: $success;
  
      &:hover {
        background-color: rgba($success, 0.12);
      }
    }
  }
  </style>
  
  <style lang="scss" scoped>
  @import '~@core/scss/base/pages/app-invoice.scss';
  @import '~@core/scss/base/components/variables-dark';
  @import '~@core/scss/vue/libs/vue-select.scss';

  .form-item-section {
    background-color: $product-details-bg;
  }
  
  .form-item-action-col {
    width: 27px;
  }
  
  .repeater-form {
    // overflow: hidden;
    transition: 0.35s height;
  }
  
  .v-select {
    &.item-selector-title,
    &.payment-selector {
      background-color: #fff;
  
      .dark-layout & {
        background-color: unset;
      }
    }
  }
  
  .dark-layout {
    .form-item-section {
      background-color: $theme-dark-body-bg;
  
      .row .border {
        background-color: $theme-dark-card-bg;
      }
    }
  }
  </style>
  